'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _configuration = require('./configuration');

exports['default'] = {
	get: _configuration.get,
	set: _configuration.set
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-global-configuration/build/index.js
// module id = ./node_modules/react-global-configuration/build/index.js
// module chunks = 0